import React from 'react';
import { Star, Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  age: number;
  childrenInfo: string;
  content: string;
}
export function TestimonialCard({
  name,
  location,
  age,
  childrenInfo,
  content
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-amber-100 relative" data-id="element-173">
      <Quote className="absolute top-4 right-4 w-8 h-8 text-amber-100" data-id="element-174" />

      <div className="flex gap-1 mb-4" data-id="element-175">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-176" />)}
      </div>

      <p className="text-gray-700 italic mb-6 relative z-10" data-id="element-177">"{content}"</p>

      <div className="mt-auto border-t border-gray-100 pt-4" data-id="element-178">
        <p className="font-bold text-gray-900" data-id="element-179">
          {name}, {age} años
        </p>
        <p className="text-sm text-gray-500" data-id="element-180">{location}</p>
        <p className="text-xs text-amber-600 font-medium mt-1" data-id="element-181">
          Mamá de {childrenInfo}
        </p>
      </div>
    </div>;
}